module.exports = __webpack_public_path__ + "img/switch_cases_syntax.70671719.png";